<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_seguro_hogar.jpg" style="width: 100%" />
    <p class="tituloTarjeta">SEGURO DE HOGAR</p>
    <p>
      Tu hogar merece estar siempre protegido y en MMT Seguros queremos que vivas con total tranquilidad con nuestro Seguro de Hogar.
    </p>
    <ul style="list-style-type: disc">
      <li><b>Cobertura completa:</b> daños por agua, incendios, robos y mucho más</li>
      <li><b>Asistencia inmediata:</b> estamos disponibles para ti cuando lo necesites</li>
      <li><b>Facilidades de pago:</b> fracciona en cómodos plazos tu seguro.</li>
    </ul>

    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llamar
        </button>
      </a>


      <a href="https://www.mmtseguros.com/calcular/seguros-hogar?id_origen=c9772407e7bd0d88fcd118acb7d33c62" target="_blank" class="link">
        <button class="pure-button botonLlamar">Calcular precio</button>
      </a>
    </p>
  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 0.5rem;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
.divHorizontal {
  display: inline-block;
  text-align: center;
}
.divCuponAmigo {
  align-items: center;
  justify-content: center;
}
</style>
